import { render } from "./RegisterAdmin.vue?vue&type=template&id=2915a2cc&scoped=true"
import script from "./RegisterAdmin.vue?vue&type=script&lang=js"
export * from "./RegisterAdmin.vue?vue&type=script&lang=js"

import "./RegisterAdmin.vue?vue&type=style&index=0&id=2915a2cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2915a2cc"]])

export default __exports__